module.exports = __webpack_public_path__ + "static/media/live-casino-fill.b4cc2551.svg";